<template>
  <div class="form__field" :style="{ width: field.size }" v-if="showCaptcha">
    <div class="form__title" v-show="field.title">{{ field.title }}</div>
    <div class="form__spacer" v-show="field.title"></div>
    <label class="form__label" v-show="field.label" :for="identifier">
      {{ field.label }}
    </label>
    <div v-if="own_captcha_implementation">
      <img src="/captcha" alt="captcha"/>
    </div>
    <div class="form__control" :style="own_captcha_implementation ? {width: '100px'} : {}">
      <template v-if="own_captcha_implementation">
        <input
          autocomplete="off"
          class="form__input"
          type="text"
          maxlength="6"
          v-model="value"
          :id="identifier"
          :name="identifier"
          :placeholder="field.data ? field.data.placeholder : ''"
          @blur="validate()"
        />
      </template>
      <template v-else>
        <input type="hidden" v-model="value" :id="identifier" :name="identifier" />
        <vue-recaptcha
          @verify="onVerifiy"
          @expired="onExpired"
          @render="onRender"
          ref="handler"
          :sitekey="field.data.sitekey"
        ></vue-recaptcha>
      </template>
    </div>
    <div
      class="form__description mod mod--style--normal mod--theme--primary mod--size--14 mod--weight--400"
      v-if="own_captcha_implementation"
    >
      Geben Sie bitte den Sicherheitscode ein.
    </div>
    <div
      class="form__message form__message--error"
      v-show="field.error"
    >
      {{ field.error }}
    </div>
    <div class="form__description" v-show="field.description">
      {{ field.description }}
    </div>
  </div>
</template>

<script>
import * as Components from ".";
import VueRecaptcha from "vue-recaptcha";

export default {
  extends: Components.CheckoutField,
  props: ["processValue"],
  name: "checkout-field-recaptcha",
  components: {VueRecaptcha},
  methods: {
    onVerifiy: function(recaptchaToken) {
      this.$store.dispatch("updateField", {
        field: this.field,
        newProps: {
          value: recaptchaToken
        }
      });
    },
    onExpired: function() {
      this.$store.dispatch("updateField", {
        field: this.field,
        newProps: {
          value: ""
        }
      });
    },
    onRender: function() {
      this.$store.dispatch("updateField", {
        field: this.field,
        newProps: {
          value: ""
        }
      });
    }
  },
  computed: {
    own_captcha_implementation() {
      return this.field.data.own_captcha_implementation === "1";
    },
    showCaptcha() {
      return ['register', 'login'].includes(this.processValue) || this.$store.state.messages;
    }
  },
  updated() {
    if (this.field.valid === false) {
      this.$refs.handler && this.$refs.handler.reset();
    }
  }
};
</script>
